<template>
    <tr>
        <td>
            <div>#{{ index + 1 }}</div>
            <div style="font-size: 0.7rem">ID: {{ category.parameterId }}</div>
        </td>
        <td>
            <a :href="categoryUrl" @click.prevent="handleOpenCategory">
                {{ category.categoryName }}
            </a>
        </td>
        <td>
            <span v-if="category.totalCompetitors > 0" class="tag is-white">
                {{ category.totalCompetitors }}
            </span>
            <span v-else class="tag is-dark">
                {{ category.totalCompetitors }}
            </span>
        </td>
        <td>
            <span class="tag is-info">
                {{ category.totalCompetitorsForStatuses[COMPETITOR_CANDIDATE_STATUS] || 0 }}
            </span>
        </td>
        <td>
            <span class="tag is-danger">
                {{ category.totalCompetitorsForStatuses[COMPETITOR_PAYMENT_DQ_STATUS] || 0 }}
            </span>
        </td>
        <td>
            <span class="tag is-warning">
                {{ category.totalCompetitorsForStatuses[COMPETITOR_FAILED_VERIFICATION_STATUS] || 0 }}
            </span>
        </td>
        <td>
            <span class="tag is-success">
                {{ category.totalCompetitorsForStatuses[COMPETITOR_VERIFIED_STATUS] || 0 }}
            </span>
        </td>
        <td>
            <DropdownButton>
                <template v-slot:trigger>
                    <button class="button is-small">
                        <span>{{ translate("common.options") }}</span>
                        <span class="icon">
                            <i class="fa fa-caret-down"></i>
                        </span>
                    </button>
                </template>
                <template v-slot:content>
                    <a class="dropdown-item" @click="handleDivideCategory">
                        <span class="icon">
                            <i class="fa fa-divide" />
                        </span>
                        <span>{{ translate("admin_categories.divide_category") }}</span>
                    </a>
                </template>
            </DropdownButton>
        </td>
    </tr>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import DropdownButton from "../Common/DropdownButton.vue";
    import { translate } from "../Common/translations";
    import { CategorySummary } from "../Api/Categories/categoriesSummary";
    import {
        COMPETITOR_CANDIDATE_STATUS,
        COMPETITOR_FAILED_VERIFICATION_STATUS,
        COMPETITOR_PAYMENT_DQ_STATUS,
        COMPETITOR_VERIFIED_STATUS,
    } from "../Common/Competitors/types";

    const props = defineProps<{
        category: CategorySummary;
        index: number;
        eventId: number;
    }>();

    const emit = defineEmits<{
        divideCategory: [parameterId: number, categoryName: string];
        openCategory: [parameterId: number];
    }>();

    const categoryUrl = computed(() => {
        return `/${window.panelLocale}/pages/admin/events/${props.eventId}/competitors?parameterId=${props.category.parameterId}`;
    });

    const handleDivideCategory = () => {
        emit("divideCategory", props.category.parameterId, props.category.categoryName);
    };

    const handleOpenCategory = () => {
        emit("openCategory", props.category.parameterId);
    };
</script>
